export default {
	data() {
		return {
			pid: null,
		};
	},
	props: {
		id: {
			type: [Number, String],
			validator(value) {
				return Number.isInteger(Number(value));
			},
		},
	},
	watch: {
		id: {
			immediate: true,
			deep: true,
			handler(newValue) {
				this.pid = Number(newValue);
			},
		},
	},
	created() {
		this.pid = Number(this.id);
	},
};
